<template>
    <div
        v-if="examination.currentStatus !== 'SUBMITTED'"
        class="item__wrapper"
        :class="{ unread: !examination.read && examinationCanBeDisplayed }"
        @click="$emit('click')"
    >
        <div>
            {{ $t('BRASTER_EXAMINATION_RESULT_FROM') }} &nbsp;
            <strong>
                {{ examination.isoDate | moment('D.MM.YYYY') }}
            </strong>
        </div>
        <div v-if="examination.additionalData" class="examination-id">
            {{ examination.additionalData }}
        </div>
        <div class="read-status">
            <span v-if="examinationNeedsToComplete">{{ $t('EXAMINATION_NEEDS_DATA') }}</span>
            <span v-if="examinationIsRejected">{{ $t('REJECTED') }}</span>
            <span v-else-if="examinationBrasterInformationReady && examination.read">{{ $t('READ') }}</span>
            <span v-else-if="examinationBrasterInformationReady && !examination.read">{{ $t('UNREAD') }}</span>
            <span v-else-if="examinationThermogramsReady">{{ $t('THERMOGRAMS_READY') }}</span>
            <span v-else-if="examinationIsVerifyingAreaLimitations">{{ $t('VERIFYING_AREA_LIMITATIONS') }}</span>
            <span v-else-if="!examinationCanBeDisplayed && !examinationNeedsToComplete">{{
                $t('DOCUMENT_NOT_PUBLISHED')
            }}</span>
            <span v-else-if="!examination.read && !examinationNeedsToComplete" class="isUnreaded">{{
                $t('UNREAD')
            }}</span>
            <span v-else-if="!examinationNeedsToComplete">{{ $t('READ') }}</span>
        </div>
        <div>
            <span :class="{ link: true, 'gray-link': !examinationCanBeDisplayed }">{{ $t('SEE') }} </span>
            <img class="link--img" src="../../../assets/images/arrow-red.png" />
        </div>
    </div>
</template>

<script>
import {
    examinationCanBeDisplayed,
    examinationIsRejected,
    examinationIsVerifyingAreaLimitations,
    examinationNeedsToComplete,
    examinationBrasterInformationReady,
    examinationThermogramsReady,
} from '../../../assets/js/examinationUtils';

export default {
    props: ['examination'],
    computed: {
        examinationCanBeDisplayed() {
            return examinationCanBeDisplayed(this.examination);
        },
        examinationIsRejected() {
            return examinationIsRejected(this.examination);
        },
        examinationNeedsToComplete() {
            return examinationNeedsToComplete(this.examination);
        },
        examinationIsVerifyingAreaLimitations() {
            return examinationIsVerifyingAreaLimitations(this.examination);
        },
        examinationBrasterInformationReady() {
            return examinationBrasterInformationReady(this.examination);
        },
        examinationThermogramsReady() {
            return examinationThermogramsReady(this.examination);
        },
    },
};
</script>

<style lang="scss" scoped>
.item__wrapper {
    border: 1px solid #ccc;
    cursor: pointer;
    color: #333333;
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    padding: 17px 20px;
    text-align: center;

    > div {
        align-items: center;
        display: flex;
        flex-grow: 2;
        justify-content: flex-start;

        &.examination-id {
            justify-content: center;
            width: 30%;
        }

        &.read-status {
            justify-content: center;
        }

        &:last-child {
            justify-content: flex-end;
        }
    }
}

.item__wrapper.unread {
    border: 1px solid #cf004a;
}

.isUnreaded {
    color: #cf004a;
    font-weight: 700;
}

.link {
    color: #cf004a;
    font-weight: 700;

    &--img {
        width: 12px;
        height: 7px;
        margin-left: 10px;
        margin-bottom: 4px;
    }
}

.gray-link {
    color: gray;
    font-weight: 700;

    &--img {
        width: 12px;
        height: 7px;
        margin-left: 10px;
        margin-bottom: 4px;
    }
}

@media (max-width: 991px) {
    .item__wrapper {
        justify-content: space-between;

        > div {
            justify-content: center;

            &.examination-id {
                width: 27%;
            }
        }
    }
}

@media (max-width: 768px) {
    .item__wrapper {
        flex-direction: column;

        > div {
            flex: 1 1 auto;
            margin-bottom: 10px;

            &.examination-id {
                width: 100%;
            }

            &:last-child {
                justify-content: center;
                margin-bottom: 0;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// result-item.vue?ba25d0f8